import React, { Component } from 'react'
import './reports.css';
import Header from '../common/Header';
import Select from 'react-select';
import Utilities from '../../global/Utilities';
import ApiServices from "../../providers/ApiServices";
import { COMMON, API_CONSTANTS, ALL_ROUTES, SYNC_SERVICE, PERMISSION_CONSTANTS } from '../../global/Constants';
import DesktopFooter from '../../components/common/DesktopFooter';
import BulkUploadSummary from './BulkUploadSummary';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SyncServices from '../../providers/SyncServices';
import AuthService from '../../providers/AuthService';
import SyncLoader from '../common/loader/SyncLoader';
import DataProvider from '../../providers/DataProvider';
import $ from 'jquery';
import Loader from '../common/loader/Loader';


class BulkUploadReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            activityData: [
                {
                    value: 1,
                    label: 'Individual Visit'
                },
                {
                    value: 2,
                    label: 'Sample Distribution'
                },
                {
                    value: 3,
                    label: 'Group Meeting'
                },
                {
                    value: 4,
                    label: 'Sample To Sale'
                }
            ],
            fdoData: [],
            cropData: [],
            hybridData: [],
            villageData: [],
            farmerDropDown: [
                {
                    value: 1,
                    label: 'Farmer'
                },
                {
                    value: 2,
                    label: 'Retailer'
                },
            ],
            growerData: [],
            selectedActivity: null,
            selectedFdo: null,
            selectedCrop: null,
            selectedHybrid: null,
            selectedVillage: null,
            selectedFarmer: null,
            numberOfRows: 0,
            regexp: /^[0-9]/,
            bulkData: [],
            checkAll: false,
            selectedRow: null,
            activities: [],
            isDraft: false,
            uploadSummary: [],
        }
    }


    async componentDidMount() {

        const session = AuthService.getSession();

        if (session) {
            const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
            if (!showBulkUpload?.view) {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                return;
            }

            toast.configure();
            const bulkData = JSON.parse(localStorage.getItem(API_CONSTANTS.BULK_DATA));
            if (bulkData !== null) {
                this.setState({ bulkData: bulkData });
            }
            this._getActivityFDOApi();
            //this._getAllVillageByIdApi();
            this._getGroverByUserId();

        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    goBack = () => {
        this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
    }

    handleDraft = () => {
        if (this.state.bulkData.length === 0) {
            toast.info('Please add some activities');
        } else {
            localStorage.setItem(API_CONSTANTS.BULK_DATA, JSON.stringify(this.state.bulkData));
            this.setState({ isDraft: true });
            toast.info('Save Data Successfully');
        }
    }

    handleUpload = () => {
        Utilities.LogPrint('Upload Data', this.state.bulkData);
        //window.$("#TablePopup").modal("show");

        this.setState({ isLoading: true });
        const activities = [];
        const len = this.state.bulkData.length;

        for (var i = 0; i < len; i++) {
            let krishakId = 0;
            let retailerId = 0;
            let obj = this.state.bulkData[i]
            if (obj.activityObject.value === 4) {
                krishakId = obj.growerObject.value
                retailerId = 0
            } else if (obj.activityObject.value !== 1 || obj.activityObject.value !== 4) {
                krishakId = 0
                retailerId = 0
            } else {
                if (obj.farmerObject.value === 1) {
                    krishakId = 1
                    retailerId = 0
                } else {
                    krishakId = 0
                    retailerId = 1
                }
            }
            activities.push({
                date: obj.date,
                assigned_user_id: obj.fdoObject.value,
                activity_type_id: obj.activityObject.value,
                crop_id: obj.cropObject.value,
                hybrid_id: obj.hybridObject.value,
                retailer_id: retailerId,
                krishak_id: krishakId,
                village_id: obj.villageObject?.value,
                stage_id: obj.activityObject?.value === 4 ? 1 : 0
            });
        }
        //Utilities.LogPrint('Upload activities', activities);
        this.activityBulkUploadApi(activities);
    }

    //Api Calls
    _getActivityFDOApi = () => {
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(users => {
            Utilities.LogPrint("users:", users);
            //this.setState({ isLoading: false });
            if (users !== undefined && users !== null && users?.length > 0) {
                const session = AuthService.getSession();
                var user = users?.find(item => item.user_id === session?.user.user_id);
                if (user) {
                    user['name'] = "Self"
                }
                Utilities.LogPrint('#fdoListArray', users);

                const firstLevelUsers = users.filter(item => (item.server_employee_id === session?.user.server_employee_id
                    || item.server_manager_id === session?.user.server_employee_id) && item.is_active === 1);

                const newArrayOfObj = firstLevelUsers.map(({ user_id: value, name: label, ...rest }) => ({ value, label, ...rest }));
                this.setState({
                    fdoData: newArrayOfObj,
                    //isLoading: false,
                });
            }
        });
    }

    _getSubActivityByIdApi = (activityTypeId) => {

        this.setState({ cropData: [] });
        var params = JSON.stringify({
            activity_type_id: activityTypeId,
        });

        Utilities.LogPrint('#Crops:', params);

        try {
            ApiServices.getSubActivityById(params)
                .then(response => {
                    var status = response.success
                    // this.props.loaderCallback(false)
                    if (status) {
                        //Utilities.LogPrint("_getSubActivityByIdApi", response.data.data);
                        //const { bulkData, selectedRow } = this.state;
                        //TODO: Change By Tejswi Mem Activity Change Retain Same

                        //TODO : BASED ON USER CROP GROUP
                        const userCrops = DataProvider.getInstance().getUserCrops();
                        const cropData = response?.data?.filter(crop => {
                            return userCrops.find(userCrop => { return userCrop.crop_group_id === crop.crop_group_id });
                        });
                        Utilities.LogPrint("Crop Group 2:", cropData);

                        let cropsArray = cropData.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }));
                        this.setState({ cropData: cropsArray, isLoading: false })
                        // if (selectedRow === null) {
                        //     let cropsArray = response.data.data.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }));
                        //     //Utilities.LogPrint('cropsArray', cropsArray);
                        //     this.setState({ cropData: cropsArray, isLoading: false })
                        // } else {
                        //     let cropsArray = response.data.data.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }));
                        //     const newState = bulkData.map(obj =>
                        //         obj.id === selectedRow ? { ...obj, cropArray: cropsArray, cropObject: cropsArray[0], hybridData: null, hybridObject: null } : obj
                        //     );
                        //     Utilities.LogPrint('#Crops bulkData', newState);
                        //     this.setState({ bulkData: newState });
                        // }
                    }
                    else {
                        this.setState({
                            isLoading: false,
                        })
                    }
                })
                .catch(error => {
                    //this.props.loaderCallback(false);
                    Utilities.LogPrint("_getSubActivityByIdApi-catch", error);
                });
        }
        catch (error) {
            //this.props.loaderCallback(false);
            Utilities.LogPrint("_getSubActivityByIdApi-error", error);
        }
    }

    _getHybridByIdApi = (crop_id) => {

        this.setState({ hybridData: [] });

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
            const hybrids = data.filter(item => { return (item.crop_id === crop_id); });

            const hybridArray = hybrids.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
            //this.setState({ hybridData: newArrayOfObj });

            const { bulkData, selectedRow } = this.state;
            if (selectedRow === null) {
                //const hybridArray = response.data.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
                this.setState({ hybridData: hybridArray, isLoading: false });
            } else {
                //const hybridArray = response.data.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
                const newState = bulkData.map(obj =>
                    obj.id === selectedRow ? { ...obj, hybridArray: hybridArray, hybridObject: hybridArray[0] } : obj
                );
                this.setState({ bulkData: newState });
            }
        });
    }

    _getAllVillageByIdApi = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data !== undefined && data !== null && data?.length > 0) {
                const villageArray = data.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }));
                this.setState({ villageData: villageArray, isLoading: false })
            }
        });
    }

    getVillages = (hybridId, selectedFdoId, isSelf = false) => {

        return new Promise(function (resolve, reject) {

            // Hybrid Location Tehsils
            SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID_LOCATION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(hybridTehsils => {

                const tehsilsAllData = DataProvider.getInstance().getTehsils();
                Utilities.LogPrint("Tehsils:", tehsilsAllData);

                const tehsilsData = tehsilsAllData.filter(tehsilRow => {
                    return hybridTehsils.find(tehsil => { return (tehsil.hybrid_id === hybridId && (tehsil.is_all_tehsil === 1 || (tehsil.tehsil_id === tehsilRow.tehsil_id && tehsil.is_all_tehsil === 0))); });
                });

                // User Locations
                SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_USER_LOCATION, SYNC_SERVICE.MASTER_TABLE).then(userLocations => {

                    const userLocationsData = userLocations.filter(userLocation => {
                        if (!isSelf) {
                            return tehsilsData.find(tehsil => { return tehsil.tehsil_id === userLocation.tehsil_id && userLocation.user_id === selectedFdoId });
                        } else {
                            return tehsilsData.find(tehsil => { return tehsil.tehsil_id === userLocation.tehsil_id });
                        }
                    });

                    // Villages
                    SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(villages => {
                        const villagesData = villages.filter(village => {
                            return userLocationsData.find(userLocation => { return userLocation.village_id === village.village_id });
                        });
                        resolve(villagesData);
                    });
                });
            });

        });
    }

    _getGroverByUserId = () => {
        this.setState({ isLoading: true });

        try {
            ApiServices.getGroverByUserId(null)
                .then(response => {
                    var status = response.success;
                    if (status) {
                        if (response.data != null) {
                            let growersLists = [];
                            for (var i = 0; i < response.data.length; i++) {
                                let data = response.data[i];
                                growersLists.push({
                                    value: data.krishak_id,
                                    label: data.name + " (" + data.phone + ")"
                                });
                            }
                            this.setState({ growerData: growersLists, isLoading: false });
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                })
                .catch(error => {
                    this.setState({ isLoading: false })
                });
        }
        catch (error) {
            this.setState({ isLoading: false });
        }
    }

    activityBulkUploadApi = (data) => {
        var params = JSON.stringify({
            "data": data
        });

        try {
            ApiServices.activityBulkUpload(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        localStorage.removeItem(API_CONSTANTS.BULK_DATA);
                        this.setState({
                            uploadSummary: response.data.count_data,
                            bulkData: [],
                            selectedActivity: null,
                            selectedCrop: null,
                            selectedHybrid: null,
                            numberOfRows: 0,
                            isLoading: false
                        }, () => {
                            setTimeout(() => {
                                $('#uploadButton').trigger('click');
                            }, 500);
                        });
                        toast.success('Activities Uploaded Successfully');
                        Utilities.LogPrint("activityBulkUpload-Response", response.data);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("activityBulkUpload", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("activityBulkUpload", error);
        }
    }


    //All Click Events
    handleActivityChange = selectedActivity => {
        this.setState({ selectedActivity });
        if (selectedActivity) {
            this._getSubActivityByIdApi(selectedActivity.value);
        }

        const { bulkData, selectedRow } = this.state;
        const newState = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, activityObject: selectedActivity } : obj
        );
        this.setState({ bulkData: newState });
    };

    handleCropChange = selectedCrop => {
        this.setState({ selectedCrop });

        const { bulkData, selectedRow } = this.state;
        const newState = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, cropObject: selectedCrop } : obj
        );
        this.setState({ bulkData: newState });

        if (this.state.selectedRow === null) {
            if (selectedCrop) {
                this._getHybridByIdApi(selectedCrop.value);
            }
        } else {
            this._getHybridByIdApi(selectedCrop.value);
        }
    };

    handleHybridChange = selectedHybrid => {
        this.setState({ selectedHybrid });
        const { bulkData, selectedRow } = this.state;
        const updateHybrid = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, hybridObject: selectedHybrid } : obj
        );
        this.setState({ bulkData: updateHybrid });
    };

    handleFdoChange = async selectedFdo => {
        this.setState({ selectedFdo });
        const { bulkData, selectedRow } = this.state;

        for (const obj of bulkData) {
            if (obj.id === selectedRow) {
                const hybridId = obj?.hybridObject?.value;

                obj.fdoObject = selectedFdo;
                const fdoId = obj?.fdoObject?.value;
                const isSelf = obj?.fdoObject?.label === "Self" ? true : false;

                this.getVillages(hybridId, fdoId, isSelf).then(villages => {
                    const villageArray = villages.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }));
                    obj.villageArray = villageArray;
                    obj.villageObject = villageArray[0];

                    this.setState({ bulkData: bulkData });
                })
            }
        }

    };

    handleVillageChange = (selectedVillage) => {
        this.setState({ selectedVillage });
        const { bulkData, selectedRow } = this.state;
        const newState = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, villageObject: selectedVillage } : obj
        );
        this.setState({ bulkData: newState });
    };

    handleFarmerChange = (selectedFarmer) => {
        this.setState({ selectedFarmer });
        const { bulkData, selectedRow } = this.state;
        const newState = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, farmerObject: selectedFarmer } : obj
        );
        this.setState({ bulkData: newState });
    };

    handleGrowerChange = selectedGrower => {
        this.setState({ selectedGrower });
        const { bulkData, selectedRow } = this.state;
        const newState = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, growerObject: selectedGrower } : obj
        );
        this.setState({ bulkData: newState });
    };

    onNumberOfRowsChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ numberOfRows: count })
        }
    }

    addNumberOfRows = () => {
        const { selectedActivity, selectedCrop, selectedHybrid } = this.state;

        if (selectedActivity === null) {
            toast.info("Please Select Activity");
            return;
        } else if (selectedCrop === null) {
            toast.info("Please Select Crop");
            return;
        } else if (selectedHybrid === null) {
            toast.info("Please Select Hybrid");
            return;
        }

        const session = AuthService.getSession();
        const activities = [];
        const len = this.state.numberOfRows;
        for (var i = 0; i < len; i++) {

            activities.push({
                id: i,
                date: Utilities.getCurrentDate(),
                assignedUserId: session?.user.user_id,
                activityArray: this.state.activityData,
                cropArray: this.state.cropData,
                hybridArray: this.state.hybridData,
                fdoArray: this.state.fdoData,
                villageArray: this.state.villageData,
                farmerArray: this.state.farmerDropDown,
                growerArray: this.state.growerData,
                activityObject: this.state.selectedActivity,
                cropObject: this.state.selectedCrop,
                hybridObject: this.state.selectedHybrid,
                fdoObject: this.state.fdoData[0],
                villageObject: this.state.villageData[0],
                farmerObject: this.state.farmerDropDown[0],
                growerObject: this.state.growerData[0],
                isChecked: false
            });
        }
        Utilities.LogPrint(activities);
        this.setState({
            bulkData: activities
        }, () => {
            const { bulkData } = this.state;
            if (bulkData?.length > 0) {
                for (const obj of bulkData) {

                    const hybridId = obj?.hybridObject?.value;
                    const fdoId = obj?.fdoObject?.value;
                    const isSelf = obj?.fdoObject?.label === "Self" ? true : false;

                    this.getVillages(hybridId, fdoId, isSelf).then(villages => {
                        const villageArray = villages.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }));
                        obj.villageArray = villageArray;
                        obj.villageObject = villageArray[0];

                        this.setState({ bulkData: bulkData });
                    })
                }
            }
        });
    }

    changeDateHandler = (e) => {
        const date = e.target.value;

        const { bulkData, selectedRow } = this.state;
        const newState = bulkData.map(obj =>
            obj.id === selectedRow ? { ...obj, date: date } : obj
        );
        this.setState({ bulkData: newState });
    }

    handleRowAction = (index) => {
        this.setState({ selectedRow: index });
    }

    handleAllChecked = (event) => {
        let bulkItems = this.state.bulkData
        bulkItems.forEach(item => item.isChecked = event.target.checked)
        this.setState({ bulkData: bulkItems, checkAll: true })
    }

    handleCheckChieldElement = (event) => {
        var data = [...this.state.bulkData];
        data[event.target.value] = { ...data[event.target.value], isChecked: !data[event.target.value].isChecked }
        this.setState({ bulkData: data });
    }

    handleDuplicate = (e) => {
        e.preventDefault();
        const data = [...this.state.bulkData];
        const duplicateData = [];

        for (var i = 0; i < data.length; i++) {
            if (data[i].isChecked) {
                let obj = data[i]
                obj.isChecked = false
                duplicateData.push(obj);
            }
        }
        const totalArray = data.concat(duplicateData)

        // now clone is a fully independent array of object with the same content
        var clonedArray = JSON.parse(JSON.stringify(totalArray))
        var counter = 0
        for (let i in clonedArray) {
            clonedArray[i].id = counter++;
        }
        this.setState({ bulkData: clonedArray, checkAll: false });
    }

    handleDelete = e => {
        this.setState(prevState => {
            return {
                bulkData: prevState.bulkData.filter(li => !li.isChecked),
                checkAll: false
            };
        });
    }

    handleSyncLoading = (loading, tableName) => {
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, activityData, cropData, hybridData, selectedActivity, selectedCrop, selectedHybrid,
            numberOfRows, bulkData, checkAll, isDraft, uploadSummary } = this.state;

        let renderUploadSummary;
        if (uploadSummary) {
            renderUploadSummary = uploadSummary.map((item, i) =>
                <BulkUploadSummary key={i} item={item} />
            );
        }

        const renderTbody = bulkData.map((row, i) => {
            return (
                <tr key={i} onClick={() => this.handleRowAction(i)}>
                    <td>
                        <label className="cutom-checkbox-container">
                            <input type="checkbox" id={row.id} checked={row.isChecked} value={row.id} onChange={this.handleCheckChieldElement} />
                            <span className="checkmark"></span>
                        </label>
                    </td>
                    <td className="input-date">
                        {/* Date Row */}
                        <input type="date"
                            className="form-control mb-0"
                            placeholder="From Date"
                            name="currentDate"
                            min={Utilities.getCurrentDate()}
                            //value={Utilities.getCurrentDate()}
                            value={row.date}
                            onChange={this.changeDateHandler} />
                    </td>
                    <td>
                        {/* Activity Row */}
                        <Select className="mb-3 max-w-360"
                            value={row.activityObject}
                            onChange={this.handleActivityChange}
                            options={row.activityArray}
                            isClearable={false}
                        />
                    </td>
                    <td>
                        {/* FDO Row */}
                        <Select className="mb-3 max-w-360"
                            value={row.fdoObject}
                            onChange={this.handleFdoChange}
                            options={row.fdoArray}
                            isClearable={false}
                        />
                    </td>
                    <td>
                        {/* Crop Row */}
                        <Select className="mb-3 max-w-360"
                            value={row.cropObject}
                            onChange={this.handleCropChange}
                            options={row.cropArray}
                            isClearable={false}
                        />
                    </td>
                    <td>
                        {/* Hybrid Row */}
                        <Select className="mb-3 max-w-360"
                            value={row.hybridObject}
                            onChange={this.handleHybridChange}
                            options={row.hybridArray}
                            isClearable={false}
                        />
                    </td>
                    <td>
                        {/* Village Row */}
                        <Select className="mb-3 max-w-360"
                            value={row.villageObject}
                            onChange={this.handleVillageChange}
                            options={row.villageArray}
                            isClearable={false}
                        />
                    </td>
                    <td>
                        {/* Farmer Row */}
                        <Select className="mb-3 max-w-360"
                            isDisabled={row.activityObject?.value !== 1}
                            value={row.farmerObject}
                            onChange={this.handleFarmerChange}
                            options={row.farmerArray}
                            isClearable={false}
                        />
                    </td>
                    <td>
                        {/* Grower Row */}
                        <Select className="mb-3 max-w-360"
                            isDisabled={row.activityObject?.value === 4 ? false : true}
                            value={row.growerObject}
                            onChange={this.handleGrowerChange}
                            options={row.growerArray}
                            isClearable={false}
                        />
                    </td>
                </tr>
            );
        });

        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-md-6">
                            <h1>Bulk Upload</h1>
                        </div>
                        <div className="col-lg-6 d-md-flex back-btn d-none">
                            {bulkData.length === 0 || isDraft === true
                                ? <button className="btn btn-secondary w-182 mr-2"
                                    onClick={this.goBack}>{COMMON.BACK}</button>
                                : <button className="btn btn-secondary w-182 mr-2"
                                    data-toggle="modal"
                                    data-target="#SaveConfirm">{COMMON.BACK}</button>
                            }

                            <button className="btn btn-secondary w-182" onClick={this.handleDraft}>
                                DRAFT
                            </button>
                            <button className="btn btn-primary w-182 ml-2"
                                onClick={this.handleUpload}
                                disabled={bulkData.length === 0 ? true : false}
                            //data-toggle="modal"
                            //data-target={this.state.isUploadSummary ? "#TablePopup" : ""
                            //disabled
                            >{COMMON.UPLOAD}</button>

                            {/* This Must be hidden */}
                            <button id="uploadButton" type="button" data-toggle="modal" data-target="#TablePopup"
                                className="d-none">placeholder</button>
                        </div>
                    </div>

                    {/* <form> */}
                    <form action="">
                        <div className="row mt-4">
                            {/* selectedActivity DropDown */}
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className="mb-3 max-w-360"
                                        value={selectedActivity}
                                        onChange={this.handleActivityChange}
                                        options={activityData}
                                        placeholder="Select activity"
                                        isClearable={true}
                                    />
                                </div>
                            </div>

                            {/* selectedCrop DropDown */}
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className="mb-3 max-w-360"
                                        value={selectedCrop}
                                        onChange={this.handleCropChange}
                                        options={cropData}
                                        placeholder="Select crop"
                                        isClearable={true}
                                    />
                                </div>
                            </div>

                            {/* selectedHybrid DropDown */}
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className="mb-3 max-w-360"
                                        value={selectedHybrid}
                                        onChange={this.handleHybridChange}
                                        options={hybridData}
                                        placeholder="Select hybrid"
                                        isClearable={true}
                                    />
                                </div>
                            </div>

                            {/* Input NumberOfRows */}
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <div className="panel-button-wrapper input-height d-flex bulk-input">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Number of rows"
                                            value={numberOfRows}
                                            disabled={false}
                                            onChange={this.onNumberOfRowsChange} />
                                        <button type="button" onClick={this.addNumberOfRows}>Add</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>


                    <div className="table-responsive">
                        <table id="" className="bulk-report display table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>
                                        <label className="cutom-checkbox-container">
                                            <input type="checkbox" onChange={this.handleAllChecked} value="checkedall" checked={checkAll} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </th>
                                    <th>Date</th>
                                    <th>Activity</th>
                                    <th>FDO</th>
                                    <th>Crop</th>
                                    <th>Hybrid</th>
                                    <th>Village</th>
                                    <th>Farmer/Retailer</th>
                                    <th>Grower Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderTbody}
                                {/* {renderTbody1} */}

                            </tbody>
                        </table>

                    </div>
                    <div className="row"><div className="col-12 button-grp-bottom mt-3">
                        <button className="btn btn-secondary w-50 mr-2" onClick={this.handleDuplicate} >{COMMON.DUPLICATE}</button>
                        <button className="btn btn-secondary w-50" data-toggle="modal" data-target="#DeleteConfirm">{COMMON.DELETE}</button>
                    </div></div>
                </div>

                {/* Delete Confirmation popup */}
                <div className="modal fade bottom-drawer" id="DeleteConfirm" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <p>Are you sure you want to Delete this?</p>
                                <div className="d-flex grey-btn">
                                    <button className="btn btn-secondary w-50 mr-2" onClick={this.handleDelete} data-dismiss="modal" aria-label="Close">Yes</button>
                                    <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Checkbox popup */}
                <div className="modal fade bottom-drawer" id="SaveConfirm" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body my-4">

                                <p>This page is asking you to confirm that you want to leave -
                                    data you have entered may not be saved.</p>
                                <div className="d-flex grey-btn">
                                    <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close" onClick={this.goBack}>OK</button>
                                    <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* table popup */}
                <div className="modal fade bottom-drawer w-100" id="TablePopup" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <table className="table table-responsive">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>FDO</th>
                                            <th>Individual Visit</th>
                                            <th>Sample Distribution</th>
                                            <th>Group Meeting</th>
                                            <th>Sample to Sale</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderUploadSummary}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}
                <DesktopFooter />

            </div >
        )
    }
}

export default BulkUploadReport